import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { SelectModule } from "ng-select";
import { NgxMaskModule } from "ngx-mask";
import { SharedModule } from "../shared/shared.module";
import { FilialComponent } from "./filial/filial.component";
import { FiltroComponent } from "./filtro/filtro.component";
import { SgGridComponent } from "./sg-grid/sg-grid.component";
import { SimpleFilterComponent } from './simple-filter/simple-filter/simple-filter.component';
import { SimpleFilterModule } from "./simple-filter/simple-filter/simple-filter.module";

@NgModule({
    declarations: [
        FiltroComponent,
        FilialComponent,
        SgGridComponent
    ],
    imports: [
        SharedModule,
        CommonModule,
        SelectModule,
        FormsModule,
        NgxMaskModule,
        SimpleFilterModule
    ],
    exports: [
        FiltroComponent,
        FilialComponent,
        SimpleFilterComponent,
        SgGridComponent
    ],
})
export class ComponentModule {
}